<template>
  <div class="body2">
    <Header @ck="onclick($event)"></Header>
    <!-- <div class="image">
      <img src="../../assets/img/628e0e4fbf573f6619e78937937b401.jp1g" alt="">
    </div> -->
    <slideshow></slideshow>
    <div class="content">
      <div class="content_w">

      
      <div class="content_box2">
        <!-- <p class="content_content">企业概况</p> -->
        <el-tabs :tab-position="tabPosition" v-model="Name">
          <el-tab-pane label="公司概况" name="1">
            <div class="content_rigth">
              <div v-show="cur == 1" class="content_rigth4">
                <div class="business">
                  <span class="titlebar">公司概况</span>
               
                  <div class="arrow-right">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >你现在所在的位置</el-breadcrumb-item
                      >
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                      >
                      <el-breadcrumb-item>企业概况</el-breadcrumb-item>
                      <el-breadcrumb-item>公司概况</el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
                <div class="enterprise_name">———企业概况———</div>
                <div class="enterprise_box1">
                  <!-- <div class="enterprise_img"> -->
                    <!-- <img :src="PagingContent.simgurl" alt="" /> -->
                  <!-- </div> -->
                  <div class="enterprise_text ql-editor" style='white-space: pre-wrap;' v-html="PagingContent[0].content">
                    <!-- &nbsp;&nbsp; &nbsp; &nbsp; -->
                 
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="公司高管" name="2">
            <Structure></Structure>
          </el-tab-pane>
          <el-tab-pane label="组织架构" name="3">
            <Architecture></Architecture>
          </el-tab-pane>
        </el-tabs>
      
      </div>
      </div>
     
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import Enterprise from "../../components/enterprise";
import Structure from "../../components/Structure";
import Architecture from "../../components/Architecture";
import slideshow from "../../components/haed/slideshow";
import axios from "axios"; //注入
import qs from "qs"; //注入

export default {
  components: {
    Header,
    Footer,
    Enterprise,
    Structure,
    Architecture,
    slideshow,
  },
  data() {
    return {
      tabPosition: "left",
      cur: 1,
      Profile: [],
      PagingContent: [],
      info: null,
      Name:"1",
    };
  },
  created() {
    this.CategoriesList();
     if(this.$route.query.name){
     
      this.Name=this.$route.query.name
    
    }
   
  },
 

 
  methods: {
    //        

    CategoriesList: function () {
      this.$axios({
        // method: "post",
        // data: qs.stringify({
        //   //           id:id,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=2&type=11",
        // header: {
        //   "Content-Type": "application/x-www-form-urlencoded", //post请求设置
        // },
      })
        .then((res) => {
          // console.log(id,"2222222222");
          this.PagingContent = res.data.rows;
        })
        .catch((res) => {});
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    //
    onclick(data){
      console.log('123',data)
      this.Name =data
    }
  },
  
};
</script>
<style scoped>
.content_w{
  width: 1000px;
  margin:  auto;
}
.content_rigth {
  margin-bottom: 10%;
  margin-top: -2%;
  margin-left: 40px;
}
.content_box2 {
  width: 100%;
  margin-top: 20px;
}
.content_content {
  width: 100px;
  height: 50px;
  /* background-color: chocolate; */
  margin-left: 100px;
  font-size: 24px;
  color: #1541a0;
}
.el-tabs__nav {
  margin-left: 25px;
}
/* .content_rigth4{
  width: 98%;
  
} */

.content {
  display: flex;

  margin-top: 28px;
  /* background-color: chocolate; */
}
.content_left {
  width: 18%;
  margin-left: 20px;
}
/* .content_rigth {
  width: 77%;
  
} */
.content_rigth1 {
  width: 77%;
  height: 57vw;
}
.descs {
  width: 36vw;
  height: 15.6vw;
  position: relative;
}
.descs_text {
  position: absolute;
  top: 44%;
  left: 40%;
  /* line-height: 18vw; */
  font-size: 2vw;
  color: #fff;
}
.descs img {
  width: 100%;
  height: 100%;
}
.left {
  width: 20%;
  /* background: blanchedalmond; */
  margin-left: 10px;
}
/* .content_left{
  width: 10%;
  margin-left:40px;
  
} */
.content_right {
  width: 80%;
  height: 40vw;
  margin-left: 10px;
}
.xz {
  width: 100%;
  text-align: center;
}
/* .el-menu{
  border-right: none;
} */
.el-menu-item:focus,
.el-menu-item:hover {
  color: #1541a0;
  background-color: #fff;
}

.tacz {
  display: flex;
  width: 12%;
  text-align: center;
  margin-left: 10px;
}
.image {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}
.image img {
  width: 100%;
  height: 100%;
}
.contentLeft_box {
  width: 100%;
  height: 50vw;
  margin-top: 20px;
  display: flex;
}
/* .content_left{
  width: 40%;
  height: 10vw;
  margin-left: 10px;
  margin-top: 10px;
} */

.el-tabs__item.is-active {
  background-color: #0c47a1;
  color: #fff;
}
.Company_text {
  font-size: 1vw;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
}
.tac el-row {
  width: 100%;
  height: 200px;
}
.slash {
  font-size: 0.5vw;
  margin-left: 10px;
  border: 1px solid #cccccc;
  margin: 0 0 -1px -1px;
  height: 1.9vw;
  line-height: 1.9vw;
  margin-left: 2px;
  text-align: center;
}
.el-submenu .el-menu-item {
  min-width: 1px;
}
.body2.el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}
.enterprise_name {
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  margin-top: 1vw;
}
.enterprise_box1 {
  width: 100%;
  margin-top: 1vw;
height: auto;
margin-left: 6%;
}
.enterprise_img {
  width: 300px;
  height: 200px;
  margin-left: 60px;
}
.enterprise_img img {
  width: 100%;
  height: 100%;
}
.enterprise_text {
  width: 80%;
  height: 100%;
  font-size: 16px;
  margin-left: 3%;
  line-height: 30px;
  color: #3d3d3d;
}
.Organization_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.Organization_img {
  width: 37vw;
  height: 17vw;
  background: url("../../assets/img/gss07.jpg") no-repeat;
  background-size: 100%;
  text-align: center;
  line-height: 18vw;
  font-size: 2vw;
  color: #fff;
}
.body2 .Company_box {
  width: 100%;
  height: 7vh !important;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
}
.Company_text {
  font-size: 1.5vw;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
}
.arrow-right {
  text-align: center;
  margin-top: 1vw;
}

.content {
  display: flex;
  /* height: 850px; */
  margin-top: 28px;
}
.content_left {
  width: 28%;
}
/* .content_rigth {
  width: 77%;
  margin-left: -10%;
  margin-bottom: 5%;
} */

.Figure_contact img {
  width: 100%;
  height: 600px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.business {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdcdc;
  margin: 0 auto;
  width: 100%;
}
.titlebar {
  font-weight: bold;
  font-size: 32px;
  color: #31518c;
  line-height: 2;
}
.crumbs {
  display: flex;
}
.crumbs span {
  color: #969696;
}
.slash {
  text-align: center;
  border: 1px solid #eee;
  margin: 0 0 -1px -1px;
  border-right: none;
  line-height: 1.9vw;
  height: 1.9vw;
}
.el-row {
  padding-left: 5%;
}
.el-submenu .el-menu-item {
  min-width: 1px;
}
.el-breadcrumb {
  line-height: 1.5 !important;
  font-size: 16px;
}
.el-tabs__item {
}
/* @media screen and (max-width: 768px) {
  .el-tabs--left .el-tabs__item.is-left {
    font-size: 12px;
  }
} */
</style>
<style>
@media screen and (min-width: 320px) and (max-width: 750px) {
  .el-tabs--left .el-tabs__item.is-left {
    font-size: 12px !important;
    
  }
  .content_rigth{
    margin-left: 5% !important ;
    margin-right: 3%;
  }
  .content{
    margin-top: -2%!important ;
  }
  .content_w{
    width: 100%;
  }
  .content_box2{
    margin-top: 0%;
  }
  .enterprise_name{
    /* width: 80%; */
    font-size: 24px !important;
    /* margin-left: 5%; */
  }
  .content_rigth4 .el-breadcrumb{
    font-size: 12px !important;
   display: none;
  }
  .body2 .el-tabs__header{
    display: none;
  }
 
  .titlebar {
    display: none;
  }
  .enterprise_text{
    width: 100% !important;
    margin-left: -7% !important;;
  }
  .enterprise_box1{
    /* margin-left: 1% !important; */
  }
  .el-tabs--left, .el-tabs--left .el-tabs__item.is-left{
    padding-right:0 !important;
  }
  /* 公司高管 */

  .struct .personnel{
      font-size: 16px !important;
      text-align: center !important;
      margin-left: 1px !important;
    }
  .struct{
    margin-top: 5%;
    width: 100%;
    margin-left: -3% !important;
  }
  .struct .member_box{
    width: 100%;
  }
  /* .struct .personnel{
    margin-left: 25%;
  } */
  .struct .name_box2{
    line-height: 1.5;
  }
  .personnel{
    text-align: center;
  }
 
  .struct .Company_text{
    display: none;
  }
  .struct .Company_box{
    /* height: 500px !important; */
    line-height: 3;
    padding-left: 5%;
    padding-top: 5%;
    display: none;
  }
  .struct .arrow-right .el-breadcrumb{
    font-size: 12px !important;
    margin-top: -5%;
  }
  /* 组织架构 */
 /* .archi{
   margin-left: -5%;
 } */
}
/*  */
.development .el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}
.el-submenu__title {
  background-color: #0c47a1;
  color: #fff;
  text-align: center;
}
.el-submenu__title:hover {
  background-color: #0c47a1;
  color: #fff;
  text-align: center;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background: #fff;
}
.el-submenu .el-menu {
  border-right: 1px;
}
.el-tabs--left,
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  padding-right: 20px;

  /* color: #eee; */
}
</style>


// WEBPACK FOOTER //
// src/pages/enterprise/enterprise.vue